import SpriteSymbol from "../../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "close-sm",
  "use": "close-sm-usage",
  "viewBox": "0 0 10 10",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 10 10\" id=\"close-sm\"><path fill=\"currentColor\" d=\"M9.186 8.149 5.798 4.76l3.37-3.37L8.149.37l-3.37 3.37-3.37-3.37-1.02 1.02 3.37 3.37L.372 8.149l1.02 1.02L4.777 5.78l3.388 3.388 1.02-1.02Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol